<template>
  <div v-if="contentBlock" :id="id" :class="contentBlockClass">
    <h3 class="title">
      <a @click.prevent="toggle">
        <i class="af-icons af-icons-info"></i>
        {{ contentBlock.title }} <i :class="chevronClass"></i>
      </a>
    </h3>
    <div class="body text-content" v-html="contentBlock.content" />
  </div>
</template>

<script>
import Storage from '@/lib/storage.js';

const Visibility = Object.freeze({
  OPEN: 'open',
  CLOSED: 'closed',
  INITIALLY: 'initially'
});

export default {
  props: {
    contentBlock: {
      type: Object,
      default: null
    },
    modelName: {
      type: String,
      default: null
    },
    modelId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      storage: null
    };
  },
  computed: {
    id() {
      return `info-box-${this.contentBlock.id}-${this.modelId}`;
    },
    contentBlockClass() {
      return [
        'entry-content-block',
        'info-box',
        this.isOpen ? Visibility.OPEN : Visibility.CLOSED
      ];
    },
    chevronClass() {
      const direction = this.isOpen ? 'down' : 'up';
      return ['af-icons', `af-icons-chevron-${direction}`];
    }
  },
  created() {
    this.storage = new Storage();

    if (this.contentBlock) {
      this.setInitialVisibility();
    }
  },
  methods: {
    toggle() {
      if (this.isOpen) {
        this.isOpen = false;
        this.storage.set(this.id, Visibility.CLOSED);
      } else {
        this.isOpen = true;
        this.storage.set(this.id, Visibility.OPEN);
      }
    },
    setInitialVisibility() {
      const visibility = this.storage.get(this.id);

      if (visibility) {
        this.isOpen = visibility === Visibility.OPEN;
        return;
      }

      switch (this.contentBlock.visibility) {
        case Visibility.OPEN:
          this.isOpen = true;
          break;
        case Visibility.CLOSED:
          this.isOpen = false;
          break;
        default:
          // Open initially, then closed
          this.isOpen = true;
          this.storage.set(this.id, Visibility.CLOSED);
          break;
      }
    }
  }
};
</script>
